import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { contentAPI, tenantAPI } from '../services/api';

const TenantContext = createContext(null);

export const useTenant = () => useContext(TenantContext);

export function TenantProvider({ children }) {
  const [currentTenant, setCurrentTenant] = useState(null);
  const [tenantData, setTenantData] = useState(null);
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tenantsLoading, setTenantsLoading] = useState(true);

  const loadTenants = useCallback(async () => {
    setTenantsLoading(true);
    try {
      const res = await tenantAPI.getAll();
      setTenants(res.data.tenants || []);
    } catch (err) {
      console.error('Failed to load tenants:', err);
      setTenants([]);
    } finally {
      setTenantsLoading(false);
    }
  }, []);

  const selectTenant = useCallback(async (slug) => {
    setLoading(true);
    setError(null);
    try {
      const res = await contentAPI.getPublicData(slug);
      setCurrentTenant(slug);
      setTenantData(res.data);
    } catch (err) {
      console.error('Failed to load tenant data:', err);
      setError(err?.response?.data?.error || 'ग्रामपंचायत माहिती लोड करताना त्रुटी आली.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTenants();
  }, [loadTenants]);

  const value = {
    currentTenant,
    tenantData,
    tenants,
    loading,
    error,
    tenantsLoading,
    selectTenant,
    setCurrentTenant,
    loadTenants,
  };

  return (
    <TenantContext.Provider value={value}>
      {children}
    </TenantContext.Provider>
  );
}
